import React from "react";
import { Footer } from "flowbite-react";
import {
  BsDribbble,
  BsFacebook,
  BsGithub,
  BsInstagram,
  BsTwitter,
} from "react-icons/bs";

export default function FooterJS() {
  return (
    <Footer container>
      <div className="w-full">
        <div className="grid w-full justify-between sm:flex sm:justify-between md:flex md:grid-cols-1">
          <div>
            <Footer.Brand
              href="/"
              src={require("./Logo.jpg")}
              alt="Wi Sol"
              name="Wi Sol"
            />
          </div>
          <div className="grid grid-cols-2 gap-8 sm:mt-4 sm:grid-cols-3 sm:gap-6">
            <div>
              <Footer.Title title="About " />
              <Footer.LinkGroup col>
                <Footer.Link href="#">Wi Sol</Footer.Link>
                <Footer.Link href="/product">Sản phẩm</Footer.Link>
                <Footer.Link href="/contact">Liên hệ</Footer.Link>
              </Footer.LinkGroup>
            </div>
            <div>
              <Footer.Title title="Theo dõi wi_sol trên:" />
              <Footer.LinkGroup col>
                <Footer.Link href="https://www.facebook.com/profile.php?id=61562925647117&mibextid=LQQJ4d">
                  Facebook
                </Footer.Link>
                <Footer.Link href="https://www.instagram.com/wi_sol.coffee?igsh=amt5dmU1dGx3OTln">
                  Instagram
                </Footer.Link>
                <Footer.Link href="https://vn.shp.ee/wSpXqn9">
                  Shoppee
                </Footer.Link>
              </Footer.LinkGroup>
            </div>
            <div>
              <Footer.Title title="Legal" />
              <Footer.LinkGroup col>
                <Footer.Link href="#">Privacy Policy</Footer.Link>
                <Footer.Link href="#">Terms &amp; Conditions</Footer.Link>
                <Footer.Link href="#">FAQS</Footer.Link>
              </Footer.LinkGroup>
            </div>
          </div>
        </div>
        <Footer.Divider />
        <div className="w-full sm:flex sm:items-center sm:justify-between">
          <Footer.Copyright href="#" by="Flowbite™" year={2022} />
          <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
            <Footer.Icon href="#" icon={BsFacebook} />
            <Footer.Icon href="#" icon={BsInstagram} />
            <Footer.Icon href="#" icon={BsTwitter} />
            <Footer.Icon href="#" icon={BsGithub} />
            <Footer.Icon href="#" icon={BsDribbble} />
          </div>
        </div>
      </div>
    </Footer>
  );
}
